import {DICT_KEY, getDictNameByCode, getModel, refreshDict, setModel} from "../../../utils/constants";
import ModelUtils from "../../../utils/ModelUtils";
import StockStatisticService from "./StockStatisticService";

const {CM_DICT} = DICT_KEY;
const MODEL_KEY = DICT_KEY.STOCK_STATISTIC;
const storageModel = getModel(MODEL_KEY);
const cacheAble = false;
const stockStatisticModel = {
    state: cacheAble && storageModel ? storageModel : {
        searchParam: {},
        stockList: [],
        stockPage: {
            total: 0,
            pageNum: 1,
            pageSize: 15
        },
        stockListSelectedRowKeys: [],
        stockStatistics: {
            inventoryNumTotal: 0,
            inventoryTypeTotal: 0,
            procurementCostTotal: 0,
            inventoryTotal: 0,
        },
        pssVisible: false,
        detailVisible: false,
        shiftVisible: false,
    },
    reducers: {
        setSearchParam(state, payload) {
            state.searchParam = {...state.searchParam, ...payload};
            setModel(MODEL_KEY, {...state});
        },
        resetSearchParam(state) {
            state.searchParam = {};
            setModel(MODEL_KEY, {...state});
        },
        setStockList(state, payload) {
            state.stockList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setStockPage(state, payload) {
            state.stockPage = payload;
            setModel(MODEL_KEY, {...state});
        },
        setStockListSelectedRowKeys(state, payload) {
            state.stockListSelectedRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
        setStockStatistics(state, payload) {
            state.stockStatistics = payload;
            setModel(MODEL_KEY, {...state});
        },
        setPssVisible(state, payload) {
            state.pssVisible = payload;
            setModel(MODEL_KEY, {...state});
        },
        setDetailVisible(state, payload) {
            state.detailVisible = payload;
            setModel(MODEL_KEY, {...state});
        },
        setShiftVisible(state, payload) {
            state.shiftVisible = payload;
            setModel(MODEL_KEY, {...state});
        }
    },
    effects: (dispatch) => ({
        async loadStockList({showMsg = true, duration = 5, data}) {
            const funName = "加载库存信息";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockStatisticService.findPage(data);
                const {list, statistics, ...page} = retData;

                list.forEach(el => {
                    el.key = el.id;
                    el.materialUnitName = getDictNameByCode(CM_DICT.MATERIAL_UNIT, el.materialUnit);
                    el.groupCodeName = getDictNameByCode(CM_DICT.MATERIAL_SORT, el.groupCode, true);
                    el.engineTypeName = getDictNameByCode(CM_DICT.ENGINE_TYPE, el.engineType);
                    el.materialBrandName = getDictNameByCode(CM_DICT.BRAND, el.materialBrand);
                    el.categoryName = getDictNameByCode(CM_DICT.MATERIAL_SORT, el.category, true);
                });
                this.setStockList(list);
                this.setStockStatistics(statistics);
                this.setStockPage(page);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },

        async shift({showMsg = true, duration = 5, data}) {
            const funName = "库存商品移库";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockStatisticService.shift(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },

        async exportStock({showMsg = true, duration = 5, data}) {
            /*const {cmDict} = dispatch;
            await refreshDict("032", cmDict);*/
            const funName = "导出库存商品";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockStatisticService.exportStock(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        }


    })
}


export default stockStatisticModel;